// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YdsUo","title":"styles_title__1bL+j","content":"styles_content__kCbgc","icon":"styles_icon__qeNDT","item":"styles_item__64AZ-"};